import { render, staticRenderFns } from "./Resource_apply.vue?vue&type=template&id=bce52b3c"
import script from "./Resource_apply.vue?vue&type=script&lang=js"
export * from "./Resource_apply.vue?vue&type=script&lang=js"
import style0 from "./Resource_apply.vue?vue&type=style&index=0&id=bce52b3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports